<template>
  <div class="ranges">
    <ul v-if="ranges">
      <li
        v-for="(value, key) in ranges"
        :key="key"
        :data-range-key="key"
        class="p-3 d-flex align-items-start rounded"
        :class="range_class(value)"
        @click="$emit('clickRange', { range: value, shortcut: key })"
      >
        <template v-if="key.includes('CUSTOM')">
          <span>{{ labelCustom(key) }}</span>
          <t-button
            class="ml-auto"
            size="sm"
            variant="link"
            @click.stop="$emit('edit', key)"
          >
            <fluency-icon type="edit"></fluency-icon>
          </t-button>
        </template>
        <template v-else>
          {{ $filters.capitalize(key) }}
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    ranges: Object,
    selected: Object
  },
  data () {
    return {
      compareOptions: [{ text: 'Previous Span', value: 'Previous Span' }]
    }
  },
  methods: {
    range_class (range) {
      const dateRangeObj = range.dateRange || range
      return {
        active:
          this.selected.startDate &&
          this.$moment(this.selected.startDate).isSame(dateRangeObj[0], 'date') &&
          this.selected.endDate &&
          this.$moment(this.selected.endDate).isSame(dateRangeObj[1], 'date')
      }
    },
    labelCustom (value) {
      const [nothing, days, offset] = value.split(':')
      let name = `Last ${days} Days`
      if (offset > 0) {
        name += `, Offset ${offset} Days`
      }
      return name
    }
  }
}
</script>
